export const neqrawBrand = {
  name: "Neqraw",
  arabicName: "نقراو",
  tagline: "On étudie. Ensemble.",
  colors: {
  "primary": "#7C3AED",
  "secondary": "#3B82F6",
  "success": "#10B981",
  "accent": "#F59E0B",
  "bg": "#0B1020",
  "surface": "#1E293B",
  "card": "#334155",
  "border": "#E2E8F0",
  "light": "#F8FAFC",
  "text_dark": "#0B1020",
  "white": "#FFFFFF"
},
  radius: { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, pill: 999 },
  spacing: { xs: 4, sm: 8, md: 12, base: 16, lg: 20, xl: 24, xxl: 32 },
  fonts: { latin: "Poppins", arabic: "Tajawal" },
} as const;
